export class MenuRightsManagement {
  administration: boolean;
  administrationSysteme: boolean;
  classementDossiers: boolean;
  classementDossiersPartiel: boolean;
  codesClassement: boolean;
  contacts: boolean;
  flux: boolean;
  mails: boolean;
  modelesDocuments: boolean;
  profiles: boolean;
  services: boolean;
  systemParameters: boolean;
  users: boolean;
}
